import React from "react";
import { Calendar } from "lucide-react";

interface UpdateDateProps {
  date: string;
  updatesSection?: React.ReactNode;
}

export function UpdateDate({ date, updatesSection }: UpdateDateProps) {
  return (
    <div className="mb-8 p-4 bg-seo-blue/10 border border-seo-bright/20 rounded-lg">
      <div className="flex items-center gap-2 mb-2">
        <Calendar className="h-5 w-5 text-seo-bright" />
        <p className="text-seo-bright font-semibold">
          Actualizado: {date}
        </p>
      </div>
      {updatesSection && (
        <div className="mt-3 text-gray-300 text-sm">
          {updatesSection}
        </div>
      )}
    </div>
  );
}
